<script lang="ts">
	import { browser } from '$app/environment';
	import { isDesktop } from '$lib/stores/utils';
	import LogoNav from '$lib/components/Marketing/LogoNav.svelte';
	import { page } from '$app/state';
	import LanguageBlocker from '$lib/components/LanguageBlocker.svelte';
	import Container from '$lib/components/App/Container.svelte';

	let { data, children } = $props();

	$isDesktop = browser && window.matchMedia('(min-width: 768px)').matches;
</script>

<svelte:window onresize={() => ($isDesktop = window.matchMedia('(min-width: 768px)').matches)} />
<svelte:boundary>
	{#if page.route.id?.includes('report') || page.route.id?.includes('pdf')}
		{@render children?.()}
	{:else}
		<div class="desktop-container">
			<main id="riva-container">
				<LogoNav supabase={data.supabase} session={data.session} />
				{#if page.params.lang !== 'fr' && browser && page.route.id?.includes('(private)')}
					<LanguageBlocker />
				{:else}
					{@render children?.()}
				{/if}
			</main>
		</div>
	{/if}

	{#snippet failed(error)}
		<div class="desktop-container">
			<main id="riva-container">
				<LogoNav supabase={data.supabase} session={data.session} />
				<Container>
					<h1>Oops! Something went wrong</h1>
					<p>Please contact us at <a href="mailto:support@riva.care">support@riva.care</a> 🙏</p>
					<pre style="background: #dde; padding:1rem; border-radius: 0.5rem;">{error}</pre>
				</Container>
			</main>
		</div>
	{/snippet}
</svelte:boundary>

<style>
	main {
		width: 100%;
		min-height: 100svh;
		display: flex;
		flex-direction: column;
		max-width: var(--max-width);
	}

	.desktop-container {
		display: flex;
		justify-content: center;

		background: var(--gradient-4);
	}

	@keyframes fadeIn {
		from {
			background: var(--background-color);
		}
		to {
			background: var(--background-color-25);
		}
	}

	@media (min-width: 768px) {
		.desktop-container {
			display: flex;
			justify-content: center;
			min-height: 100vh;
		}
		main {
			position: relative;
			overflow: auto;
		}
	}
</style>
